import style from './scss/SkeletonLoader.module.scss';

const SkeletonLoader = ({data}: any) => {
    return (
        <>
            <div className={style['loader-container']}>
                <div className={style['logo-col']}>
                </div>
                <div className={style['col2']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
                <div className={style['col3']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                    <div className={style['elipse3']}/>
                </div>
                <div className={style['col4']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
                <div className={style['col5']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
                <div className={style['col6']}>
                    <div className={style['circle']}/>
                </div>
                <div className={style['col7']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
            </div>
            <div className={style['loader-container-mobile']}>
                <div className={style['col1']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
                <div className={style['col2']}>
                    <div className={style['elipse1']}/>
                    <div className={style['elipse2']}/>
                </div>
                <div className={style['col3']}>
                    <div className={style['circle']}/>
                </div>
                <div className={style['col4']}>
                    <div className={style['square']}/>
                </div>
            </div>
        </>
    )
}

export default SkeletonLoader;
